import axios from 'axios';
import { notification } from 'antd';

export const getUser = (loginToken) => (dispatch) => {
  dispatch({
    type: 'GET_USER_REQUEST',
    payload: { loading: true },

  });
  return axios({
    url: '/api/get_user ',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${loginToken}`
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (flag) {
      const { data: response } = data;
      const { user_info } = response;

      let user = {
        ...user_info
      };
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginToken}`;
      delete user.api_token;

      return dispatch({
        type: 'GET_USER_SUCCESS',
        payload: {
          ...user,
          loginToken,
          loading: false
        }
      });
    } else {
      const { message } = data;
      notification.error({
        message: 'GET USER',
        description: message && message.error ? message.error : 'User details could not be fetched !'
      });
      return dispatch({
        type: 'GET_USER_FAILED',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'GET USER',
      description: error.message
    });

    return dispatch({
      type: 'GET_USER_FAILED',
      payload: { loading: false }
    });
  })
}

export const logout = () => (dispatch) => {
  delete axios.defaults.headers.common.Authorization
  return dispatch({
    type: 'LOGOUT_USER'
  });
}

export const registerUser = ({
  fname,
  lname,
  email,
  password,
  phoneNumber
}) => (dispatch) => {
  dispatch({
    type: 'REGISTER_USER_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/registerAsUser',
    method: 'POST',
    data: {
      first_name: fname,
      last_name: lname,
      email,
      password,
      phone: phoneNumber,
      isSocialLogin: false
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (flag) {
      const { message, data: response } = data;
      const { user_info } = response;

      const loginToken = user_info.api_token;
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginToken}`;
      localStorage.setItem('loginToken', loginToken);

      notification.success({
        message: 'SIGNUP',
        description: message.message
      });
      let user = {
        ...user_info
      };
      delete user.api_token;
      return dispatch({
        type: 'REGISTER_USER_SUCCESS',
        payload: {
          ...user,
          loginToken,
          loading: false
        }
      });
    } else {
      const { message } = data;
      notification.error({
        message: 'SIGNUP',
        description: message && message.error ? message.error : 'SIGNUP NOT SUCCESSFULL !'
      });
      return dispatch({
        type: 'REGISTER_USER_FAILED',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'SIGNUP',
      description: error.message
    });

    return dispatch({
      type: 'REGISTER_USER_FAILED',
      payload: { loading: false }
    });
  })
}

export const loginUser = ({
  userNameOrEmail,
  password
}) => (dispatch) => {
  dispatch({
    type: 'LOGIN_USER_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/login',
    method: 'POST',
    data: {
      email: userNameOrEmail,
      password,
      isSocialLogin: false
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (flag) {
      const { message, data: response } = data;
      const { user_info } = response;

      const loginToken = user_info.api_token;
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginToken}`;
      localStorage.setItem('loginToken', loginToken);

      notification.success({
        message: 'LOGIN',
        description: message.message
      });
      let user = {
        ...user_info
      };
      delete user.api_token;
      return dispatch({
        type: 'LOGIN_USER_SUCCESS',
        payload: {
          ...user,
          loginToken,
          loading: false
        }
      });
    } else {
      const { message } = data;
      notification.error({
        message: 'LOGIN',
        description: message && message.error ? message.error : 'LOGIN NOT SUCCESSFULL !'
      });
      return dispatch({
        type: 'LOGIN_USER_FAILED',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'LOGIN',
      description: error.message
    });

    return dispatch({
      type: 'LOGIN_USER_FAILED',
      payload: { loading: false }
    });
  })
}